module.exports = __webpack_public_path__ + "icons.b06871f281fee6b241d6.ttf";


//////////////////
// WEBPACK FOOTER
// /var/www/luvi/frontend/src/assets/semantic/src/themes/themes/default/assets/fonts/icons.ttf
// module id = ../../../../../src/assets/semantic/src/themes/themes/default/assets/fonts/icons.ttf
// module chunks = styles